enum MissionBonusOfferType {
  GAMIFICATION = 'Gamification',
  DEPOSIT = 'Deposit',
}

export default MissionBonusOfferType
